// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'normalize.css/normalize.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/index.scss' // global css
import App from './App'
import store from './store'
import router from './router'

import i18n from './lang' // internationalization
import './icons' // icon
import './permission' // permission control
import directive from '@/directive/permission/index'
import VueCropper from 'vue-cropper'
import Print from 'vue-print-nb'
import * as filters from './filters' // global filters
import components from '@/components'
import globalMethods from '@/utils/globalMethods' // 定义全局methods
import math from '@/utils/math' // 定义全局methods
Vue.use(globalMethods)
Vue.use(components)
Vue.use(VueCropper)
Vue.use(Print)
Vue.use(math)
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.use(directive.install)
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js